<div class="recovery-layout">
  <div class="card">
    <div class="card-title">
      <span>Expected Recovery Timeline</span>
      <span *ngIf="isLoading" class="loader-sm" style="margin-left:10px;"></span>
    </div>
    <div class="chart-wrapper" style="height: 300px;" [class.loading-opacity]="isLoading">
      <canvas id="recoveryChart"></canvas>
    </div>
  </div>

  <div class="card">
    <div class="card-title">Approved Records by Recovery Month</div>
    <div class="timeline-container" style="max-height: 300px; overflow-y: auto;" [class.loading-opacity]="isLoading">
      <div *ngFor="let group of recoveryData" class="timeline-item"
        style="margin-bottom: 10px; border: 1px solid var(--border); border-radius: 8px; padding: 10px;">
        <div class="timeline-header" (click)="group.open = !group.open"
          style="cursor: pointer; display: flex; justify-content: space-between; align-items: center;">
          <span style="font-weight: 600;">📅 {{group.key}}</span>
          <span style="color:var(--text-muted); font-size:12px;">{{group.records.length}} records</span>
        </div>
        <div class="timeline-content" *ngIf="group.open" style="margin-top: 10px;">
          <table style="width:100%; font-size:11px; border-collapse:collapse;">
            <thead>
              <tr style="background:#f8fafc;">
                <th style="padding:6px; text-align:left;">NDA Number</th>
                <th style="padding:6px; text-align:left;">Brand Name</th>
                <th style="padding:6px; text-align:left;">Route</th>
                <th style="padding:6px; text-align:left;">NDC</th>
                <th style="padding:6px; text-align:left;">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of group.records" style="border-bottom:1px solid var(--border);">
                <td style="padding:6px;">{{item.nda || 'N/A'}}</td>
                <td style="padding:6px;">{{item.brand_name || 'N/A'}}</td>
                <td style="padding:6px;">{{item.route || 'N/A'}}</td>
                <td style="padding:6px;">
                  <span class="ndc-link" (click)="openNdcDetailsModal(item, group, $event)">
                    {{item.ndc || 'N/A'}}
                  </span>
                </td>
                <td style="padding:6px;">
                  <span [style.color]="item.status === 'Current' ? '#dc2626' : '#16a34a'">{{item.status}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <p *ngIf="recoveryData.length === 0 && !isLoading"
        style="text-align:center; padding:20px; color:var(--text-muted);">No recovery data found.</p>
    </div>
  </div>

  <!-- Modal Popup for NDC Details -->
  <div class="modal-overlay" *ngIf="showNdcDetailsModal" (click)="closeNdcDetailsModal()">
    <div class="modal-card" (click)="$event.stopPropagation()" style="max-width: 800px; width: 90%; max-height: 90vh;">
      <div class="modal-header">
        <h3 style="margin: 0; color:var(--primary); font-size: 18px; font-weight: 600;">NDC Details</h3>
        <button class="modal-close-btn" (click)="closeNdcDetailsModal()">
          <i class="pi pi-times"></i>
        </button>
      </div>
      <div class="modal-body" style="padding: 24px; overflow-y: auto;">
        <!-- Product/Group Level Info -->
        <div
          style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px 24px; margin-bottom: 24px; padding-bottom: 20px; border-bottom: 1px solid #f1f5f9;">
          <div>
            <div
              style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; margin-bottom: 4px;">
              Brand Name</div>
            <div style="font-weight: 700; font-size: 15px; color: #334155; text-transform: uppercase;">
              {{selectedNdcDetails?.brand_name || 'N/A'}}</div>
          </div>
          <div>
            <div
              style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; margin-bottom: 4px;">
              NDA</div>
            <div style="font-weight: 700; font-size: 15px; color: #334155;">{{selectedNdcDetails?.nda || 'N/A'}}</div>
          </div>
          <div>
            <div
              style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; margin-bottom: 4px;">
              Dosage Form</div>
            <div style="font-weight: 700; font-size: 15px; color: #334155; text-transform: uppercase;">
              {{formatArrayOrString(selectedNdcDetails?.dosage_forms)}}
            </div>
          </div>
          <div>
            <div
              style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; margin-bottom: 4px;">
              Route</div>
            <div style="font-weight: 700; font-size: 15px; color: #334155; text-transform: uppercase;">
              {{formatArrayOrString(selectedNdcDetails?.route)}}
            </div>
          </div>
        </div>

        <!-- NDC Details Card style -->
        <div
          style="border: 1px solid #eef2f6; border-radius: 12px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.02); margin-bottom: 16px;">
          <!-- NDC Header -->
          <div
            style="background: #f8fafc; padding: 14px 20px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #eef2f6;">
            <div style="display: flex; gap: 24px; align-items: center; flex-wrap: wrap;">
              <div>
                <span
                  style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; display: block; margin-bottom: 2px;">NDC
                  Number</span>
                <span style="font-weight: 700; font-size: 14px; color: #334155;">{{selectedNdcDetails?.ndc}}</span>
              </div>
              <div>
                <span
                  style="font-size: 11px; color: var(--text-muted); font-weight: 700; text-transform: uppercase; display: block; margin-bottom: 2px;">Strength</span>
                <span style="font-weight: 700; font-size: 14px; color: #334155;">{{selectedNdcDetails?.strength ||
                  'N/A'}}</span>
              </div>
            </div>
            <div>
              <span [style.color]="getVal(selectedNdcDetails?.latest_record?.status) === 'Current' ? '#dc2626' : '#16a34a'"
                style="font-size: 11px; font-weight: 700;">
                {{getVal(selectedNdcDetails?.latest_record?.status)}}
              </span>
            </div>
          </div>

          <!-- NDC Detail Body -->
          <div style="padding: 20px; background: #fff;">
            <div
              style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; flex-wrap: wrap; gap: 12px;">
              <h4 style="font-weight: 700; font-size: 16px; color: var(--primary); margin: 0;">
                {{getVal(selectedNdcDetails?.latest_record?.company_name)}}
              </h4>
              <div style="display: flex; align-items: center; gap: 8px;">
                <span style="font-size: 13px; color: #64748b;">Date of Update:</span>
                <span style="color: #2563eb; font-size: 11px; font-weight: 700;">
                  {{getFormattedDate(selectedNdcDetails?.latest_record?.date_of_update) ||
                  getFormattedDate(selectedNdcDetails?.latest_record?.created_at)}}
                </span>
              </div>
            </div>

            <!-- 2 Column Details Grid -->
            <div
              style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px 32px; margin-bottom: 20px; font-size: 13px;">
              <div style="display: flex; align-items: center; flex-wrap: wrap;">
                <span style="font-weight: 700; color: #334155;">Generic Name:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getVal(selectedNdcDetails?.latest_record?.generic_name)}}</span>
              </div>
              <div style="display: flex; align-items: center; flex-wrap: wrap;">
                <span style="font-weight: 700; color: #334155;">Update Type:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getVal(selectedNdcDetails?.latest_record?.type_of_update)}}</span>
              </div>
              <div style="display: flex; align-items: center; flex-wrap: wrap;">
                <span style="font-weight: 700; color: #334155;">Date of Discontinued:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getFormattedDate(selectedNdcDetails?.latest_record?.date_discontinued)}}</span>
              </div>
              <div style="display: flex; align-items: center; flex-wrap: wrap;">
                <span style="font-weight: 700; color: #334155;">Initial Posting Date:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getFormattedDate(selectedNdcDetails?.latest_record?.initial_posting_date)}}</span>
              </div>
              <div style="display: flex; align-items: center; flex-wrap: wrap;">
                <span style="font-weight: 700; color: #334155;">Availability Info:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getVal(selectedNdcDetails?.latest_record?.availability_information)}}</span>
              </div>
              <div style="display: flex; align-items: center; flex-wrap: wrap;">
                <span style="font-weight: 700; color: #334155;">Therapeutic Category:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getVal(selectedNdcDetails?.latest_record?.therapeutic_category)}}</span>
              </div>
              <div style="display: flex; align-items: center; flex-wrap: wrap; grid-column: span 2;">
                <span style="font-weight: 700; color: #334155;">Presentation:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getVal(selectedNdcDetails?.latest_record?.presentation)}}</span>
              </div>
              <div style="display: flex; align-items: center; flex-wrap: wrap; grid-column: span 2;"
                *ngIf="getVal(selectedNdcDetails?.latest_record?.resolved_note) !== 'N/A'">
                <span style="font-weight: 700; color: #334155;">Resolved Note:</span>
                <span
                  style="color: #475569; margin-left: 6px;">{{getVal(selectedNdcDetails?.latest_record?.resolved_note)}}</span>
              </div>
            </div>

            <!-- Description fields -->
            <div style="font-size: 13px; padding-top: 16px; border-top: 1px solid #eef2f6;">
              <div style="margin-bottom: 8px; display: flex; align-items: flex-start;">
                <span style="font-weight: 700; color: #334155; min-width: 150px; display: inline-block;">Reason of
                  Shortage:</span>
                <span
                  style="color: #64748b; flex: 1;">{{getVal(selectedNdcDetails?.latest_record?.reason_for_shortage)}}</span>
              </div>
              <div style="display: flex; align-items: flex-start;">
                <span style="font-weight: 700; color: #334155; min-width: 150px; display: inline-block;">Related
                  Information:</span>
                <span
                  style="color: #64748b; flex: 1;">{{getVal(selectedNdcDetails?.latest_record?.related_information)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeNdcDetailsModal()">Close</button>
      </div>
    </div>
  </div>
</div>